import React, { useRef, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import { AnchorLink } from 'gatsby-plugin-anchor-links'
import ReCAPTCHA from 'react-google-recaptcha'
import cn from 'classnames'

import api from '~/siteApi'

import * as st from '~/assets/styl/Contact.module.styl'

import formatPhone from '~/utils/formatPhone'
import { navigate } from 'gatsby'

export default function Contact() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [message, setMessage] = useState('')
  const [privacy, setPrivacy] = useState(false)
  const [communications, setCommunications] = useState(false)
  const recaptchaRef = useRef<ReCAPTCHA>()

  function handleName(e) {
    setName(e.target.value)
  }

  function handleEmail(e) {
    setEmail(e.target.value)
  }

  function handlePhone(e) {
    setPhone(formatPhone(e.target.value))
  }

  function handleMessage(e) {
    setMessage(e.target.value)
  }

  function handleTermo(e) {
    setPrivacy(e.target.checked)
  }

  function handleComunicacao(e) {
    setCommunications(e.target.checked)
  }

  function handleSubmit(e) {
    e.preventDefault()

    recaptchaRef.current.executeAsync().then((recaptcha) => {
      recaptchaRef.current.reset()

      const bypass = process.env.GATSBY_RECAPTCHA_BYPASS
      const isDev = process.env.NODE_ENV === 'development'

      api('post', 'leads/contact', {
        name,
        email,
        phone,
        message,
        privacy,
        consent: communications,
        recaptcha: isDev && bypass ? bypass : recaptcha,
      })
        .then(() => {
          setName('')
          setEmail('')
          setPhone('')
          setMessage('')
          navigate('/obrigado')
        })
        .catch((error) => {
          alert(
            error?.message ||
              'Não foi possível enviar sua mensagem. Tente novamente.'
          )
        })
    })
  }

  const isMobile = useMediaQuery({ query: '(max-width: 1080px)' })

  return (
    <div id="atendimento" className={cn(st.contactContainer, 'page-width')}>
      <section className={st.informations}>
        <h2>Entre em contato com a nossa equipe</h2>
        <p>
          Utilize o formulário e envie uma mensagem para nossos consultores.
        </p>
        <section className={st.attendance}>
          <h3>Atendimento Dimas Sempre</h3>
          <a
            href="https://api.whatsapp.com/send?phone=554899229019&text=Ol%C3%A1!%20Vim%20pelo%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20Assinatura%20Veicular."
            target="_blank"
            rel="noreferrer external nofollow"
          >
            <span className="icon-whatsapp"></span>
            Chame no WhatsApp
          </a>
        </section>
        <section className={st.address}>
          <h3>Nosso escritório</h3>
          <address>
            Av. Mar Max Schramm nº 2700
            <br />
            Estreito, Florianópolis - CEP 88095-000
          </address>
          <a
            href="https://www.google.com/maps/dir//Concession%C3%A1ria+Ford+Dimas+-+Estreito+-+Av.+Marinheiro+Max+Schramm,+2700+-+Jardim+Atl%C3%A2ntico,+Florian%C3%B3polis+-+SC,+88095-000/@-27.5789907,-48.5888661,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x9527482f6037938b:0xe95afeedbe74c46b!2m2!1d-48.5888661!2d-27.5789907!3e0"
            target="_blank"
            rel="noreferrer external nofollow"
          >
            Traçar uma rota no Google
          </a>
        </section>
        <a className={st.work} href="http://www.dimas.com.br/trabalhe-conosco">
          Trabalhe Conosco
        </a>
      </section>
      {isMobile && <div className={st.divider}></div>}
      <form onSubmit={handleSubmit}>
        <div className={st.formWrapper}>
          <label>
            Nome
            <input
              type="text"
              placeholder="Qual seu nome?"
              value={name}
              onChange={handleName}
              required
            />
          </label>
          <label>
            E-mail
            <input
              type="email"
              placeholder="Digite seu melhor e-mail"
              value={email}
              onChange={handleEmail}
              required
            />
          </label>
          <label>
            Whatsapp
            <input
              type="tel"
              placeholder="Qual seu numero para contato?"
              value={phone}
              onChange={handlePhone}
              maxLength={15}
              required
            />
          </label>
          <label>
            Mensagem
            <textarea
              value={message}
              placeholder="Insira sua mensagem"
              cols={30}
              rows={10}
              onChange={handleMessage}
            ></textarea>
          </label>
        </div>
        <div className={st.privacy}>
          <label>
            <input
              id="use_terms_privacy"
              type="checkbox"
              name="termo"
              onChange={handleTermo}
              required
            />
            <small>
              Eu concordo em receber comunicações. Ao informar meus dados, eu
              concordo com a
              <AnchorLink to="/politica-de-privacidade/">
                Política de privacidade
              </AnchorLink>
              e<AnchorLink to="/termos-de-uso/">Termos de uso</AnchorLink>
            </small>
          </label>
          <label>
            <input
              id="use_terms_comunicacao"
              type="checkbox"
              name="comunicacao"
              onChange={handleComunicacao}
              required
            />
            <small>
              Autorizo o Grupo Dimas a armazenar meus dados pessoais para enviar
              campanhas de marketing e informações sobre a empresa nos canais:
              Telefone, Email e SMS.
            </small>
          </label>
        </div>
        {process.env.GATSBY_RECAPTCHA_KEY && (
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={process.env.GATSBY_RECAPTCHA_KEY}
            size="invisible"
          />
        )}
        <button type="submit">Enviar</button>
      </form>
    </div>
  )
}
